import { InputText } from "primereact/inputtext";
import PageContent from "../../components/PageContent";
import PageTitle from "../../components/PageTitle";
import { InputMask } from 'primereact/inputmask';
import { useState } from "react";
import { Button } from "primereact/button";
import useApi from "../../hooks/ApiHook";
import useToast from "../../hooks/ToastHook";
import If from "../../components/If";
import { ConfirmDialog } from 'primereact/confirmdialog';
import { confirmDialog } from 'primereact/confirmdialog';
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export default function() {

    const api = useApi();
    const navigate = useNavigate();
    const { showAxiosError, showSuccess } = useToast();
    const [ document, setDocument ] = useState('');
    const [ loading, setLoading ] = useState(false);
    const [ company, setCompany ] = useState();

    const search = e => {
        e.preventDefault();
        setLoading(true);
        api.get('suppliers/find', { params: { document } }).then(({ data }) => {
            setCompany(data);
        }).catch(showAxiosError).finally(() => setLoading(false));
    }

    const askConnection = () => {
        confirmDialog({
            message: 'Ao solicitar uma conexão com um distribuidor, o mesmo será notificado e poderá aceitar ou não a solicitação. Enquanto isso, a conexão aparecerá com o status de AGUARDANDO na listagem de conexões.',
            header: 'Atenção',
            icon: 'pi pi-exclamation-triangle',
            draggable: false, 
            className: "col-12 md:col-8 lg:col-4 xl:col-4",
            acceptLabel: 'Continuar',
            rejectLabel: 'Cancelar',
            accept: createConnection
        });
    }

    const createConnection = () => {
        setLoading(true);
        api.post('suppliers', { supplierId: company.id }).then(({ data }) => {
            showSuccess('Conexão criada. Aguarde o distribuidor aceitar para poder realizar movimentações.');
            navigate(-1);
        }).catch(showAxiosError).finally(() => setLoading(false));
    }

    const companyAsArray = () => {
        return [
            { property: "Razão social",  value: company.corporateName },
            { property: "CPF/CNPJ",  value: company.document },
            { property: "Cidade",  value: company.address.city },
            { property: "Estado",  value: company.address.state },
        ];
    }

    return (
        <div>
            <PageTitle 
                title="Adicionar nova conexão" 
                subtitle="Faça a busca abaixo pelo CPF ou CNPJ da distribuídora que deseja se conectar e verifique os dados para vincular o estoque"/>
            <PageContent>
                {!company &&
                    <form onSubmit={search}>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-6 lg:col-4">
                                <label className="w-full">CPF/CNPJ</label>
                                <InputMask 
                                    value={document} 
                                    unmask
                                    required
                                    onChange={(e) => setDocument(e.target.value)} 
                                    mask={document.length === 11 ? "999.999.999-99?9" : "99.999.999/9999-99"} 
                                    placeholder="CPF/CNPJ"/>
                            </div>
                        </div>
                        <div className="mt-2">
                            <Button label="Buscar" className="mr-2" loading={loading}/>
                            <Button label="Cancelar" outlined onClick={() => navigate(-1)}/>
                        </div>
                    </form>
                }
                {!!company && 
                    <>
                        <Button 
                            icon="pi pi-arrow-left" 
                            label="Voltar" 
                            className="mb-2 -mt-3 -ml-3 p-button-text p-button-rounded" 
                            onClick={() => setCompany(undefined)}/>
                        <div className="text-2xl mb-2">{company?.commercialName}</div>
                        <DataTable className="mb-5" value={companyAsArray()}>
                            <Column field="property" style={{ width: '20%' }}></Column>
                            <Column field="value"></Column>
                        </DataTable>
                        <Button className="mr-2" label="Solicitar conexão" loading={loading} onClick={askConnection}/>
                    </>
                }
            </PageContent>
            <ConfirmDialog/>
        </div>
    );


}